import { DismissedConflictsStore } from "sh-conflict-store";
import { IConflictDismissEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('REMOVE_DISMISSED_CONFLICT_ENTITY', function removeDismissedConflictEntity(dismissedEntity: IConflictDismissEntity) {
    if (dismissedEntity && DismissedConflictsStore().entityIdToDismissedConflictEntities.has(dismissedEntity.id)) {
        DismissedConflictsStore().entityIdToDismissedConflictEntities.delete(dismissedEntity.id);
    }
});
